module.exports = __webpack_public_path__ + "img/图片9.57ea82cc.png";